/* ═══════════════════════════════════════════════════════════════
   OrgChartEdgeService — CRUD for the visual org-chart edges table

   Decoupled from `team_members.reportsTo` so users can:
     • Draw any number of lines into a single member (multi-parent)
     • Pick dashed/solid/dotted per line (not derived from data shape)
     • Color, label, and route each line independently

   The TeamPage org-chart code is the only caller. reportsTo is still
   updated in lock-step with the "primary" edge by the chart logic so
   the rest of the system (permissions, hierarchy traversal) keeps
   working — that wiring lives in TeamPage, not here.
   ═══════════════════════════════════════════════════════════════ */

import * as cache from './cloudCache';
import type { OrgChartEdge } from '../../shared/entities';

// `waypoints` is the only jsonb field; everything else is a scalar
// column. Declaring it here keeps cloudCache from accidentally
// stringifying the array twice and lets a future read trip back to JS
// objects without manual parsing.
const TABLE_OPTS: cache.TableOpts = { jsonFields: ['waypoints'] };

export const OrgChartEdgeService = {
  list: async (): Promise<OrgChartEdge[]> =>
    cache.list<OrgChartEdge>('org_chart_edges', TABLE_OPTS),

  save: async (edge: OrgChartEdge): Promise<OrgChartEdge> =>
    cache.save<OrgChartEdge>('org_chart_edges', edge, TABLE_OPTS),

  delete: async (id: string): Promise<void> => cache.remove('org_chart_edges', id),
};
